// @core/stores/activity/ActivityActivitySettingStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { activityApi } from '@core/api';
import type {
  GetActivitySettingsResponse,
  UpdateActivitySettingsRequest,
  UpdateActivitySettingsResponse,
} from '@core/types/activity';

class ActivityActivitySettingStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Get activity settings
   */
  async GetActivitySettings(params?: { }): Promise<GetActivitySettingsResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await activityApi.GetActivitySettings(params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Update activity settings
   */
  async UpdateActivitySettings(data: UpdateActivitySettingsRequest): Promise<UpdateActivitySettingsResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await activityApi.UpdateActivitySettings(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const activityActivitySettingStore = new ActivityActivitySettingStore();
